import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import Header from "../components/Header/Header"
import Footer from '../components/Footer/Footer'
import Mostordered from "../components/Mostordered/Mostordered"
import TrendingProducts from "../components/TrendingProducts/TrendingProducts"
import FeatureProducts from "../components/FeatureProducts/FeatureProducts"
import Categories from "../components/Categories/Categories"
import secondHeader from "../assets/secondHeader.png"
import axios from 'axios'
function Home() {
  const [products, setProducts] = useState([])
  const [mostordered, setMostordered] = useState([])
  const [categories, setCategories] = useState([])
useEffect(() => {
  const getData = async () => {
    try {
      const [productsRes, categoriesRes,mostorderedRes] = await Promise.all([
        axios.get("https://nanosoft.technology/outlaw/api/products"),
        axios.get("https://nanosoft.technology/outlaw/api/categories"),
        axios.get("https://nanosoft.technology/outlaw/api/restaurants/1/products/most-ordered"),

      ]);
setMostordered(mostorderedRes.data.data);

      setProducts(productsRes.data.data);
      setCategories(categoriesRes.data.data.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  getData();
}, []);

  return (
    <div>
      <NavbarContainer />
      <Header
        headerSection={[]}
      />
      {/* <Categories
      categoriesItems={categories}
      /> */}

      {/* <TrendingProducts
        products={products}
      /> */}
      <Mostordered
        products={products}
      />
      <FeatureProducts/>
      {/* <img src={secondHeader} alt='Features' className='w-100 secondHeader'style={{height: "50vh",objectFit:"cover"}} /> */}

      <Footer />
    </div>
  )
}

export default Home